__turbopack_context__.v({
  "amount": "KD-P7G_amount",
  "from": "KD-P7G_from",
  "fromOffer": "KD-P7G_fromOffer",
  "inverse": "KD-P7G_inverse",
  "left": "KD-P7G_left",
  "offer": "KD-P7G_offer",
  "offerAccent": "KD-P7G_offerAccent",
  "original": "KD-P7G_original",
  "priceGroup": "KD-P7G_priceGroup",
  "priceGroupOffer": "KD-P7G_priceGroupOffer",
  "priceLeft": "KD-P7G_priceLeft",
  "right": "KD-P7G_right",
  "root": "KD-P7G_root",
  "sizeL": "KD-P7G_sizeL",
  "srOnly": "KD-P7G_srOnly",
  "unit": "KD-P7G_unit",
});
